import { useParams } from 'react-router-dom';
import { EmployeeFormPage } from '@personnel/presentation/components/shared';

/**
 * Employee Edit Page
 *
 * Page for editing an existing employee.
 * Wrapper component that delegates to EmployeeFormPage with mode='edit'.
 * Route: /employees/:employeeUuid/edit
 *
 * Uses employeeUuid as key to force remount when navigating between different employees.
 * This ensures clean state and proper form initialization.
 *
 * @returns {React.ReactElement} Employee edit page component
 *
 * @example
 * // In router
 * <Route path="/employees/:employeeUuid/edit" component={EmployeeEditPage} />
 */
export const EmployeeEditPage = (): React.ReactElement => {
  const { employeeUuid } = useParams<{ employeeUuid: string }>();

  // Use employeeUuid as key to force remount when navigating between employees
  // This prevents stale state from previous employee edits
  return <EmployeeFormPage key={employeeUuid} mode="edit" submitLabel={'Edit'} />;
};
